module.exports = __webpack_public_path__ + "img/level_11_blackgold.bcde1caf.svg";